import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email", "submit", "submitText"];
  static classes = ["loading"];

  connect() {
    this.originalSubmitText = this.submitTextTarget.textContent;
  }

  validate(event) {
    const email = this.emailTarget.value.trim();

    if (!email) {
      event.preventDefault();
      this.showError("Please enter your email address");
      return false;
    }

    if (!this.isValidEmail(email)) {
      event.preventDefault();
      this.showError("Please enter a valid email address");
      return false;
    }

    this.clearError();
    this.showLoading();
    return true;
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  showLoading() {
    this.submitTarget.disabled = true;
    this.submitTextTarget.textContent = "Subscribing...";
    // Use provided loading class or fall back to opacity
    const loadingClass = this.hasLoadingClass
      ? this.loadingClass
      : "opacity-75";
    this.element.classList.add(loadingClass);
  }

  hideLoading() {
    this.submitTarget.disabled = false;
    this.submitTextTarget.textContent = this.originalSubmitText;
    // Use provided loading class or fall back to opacity
    const loadingClass = this.hasLoadingClass
      ? this.loadingClass
      : "opacity-75";
    this.element.classList.remove(loadingClass);
  }

  showError(message) {
    // Remove any existing error message
    this.clearError();

    // Create error element
    const errorElement = document.createElement("div");
    errorElement.className = "text-red-400 text-sm mt-2";
    errorElement.textContent = message;
    errorElement.dataset.newsletterError = "";

    // Insert after the form
    this.element.insertAdjacentElement("afterend", errorElement);

    // Add error styling to email input
    this.emailTarget.classList.add(
      "border-red-400",
      "focus-visible:ring-red-400",
    );
  }

  clearError() {
    // Remove error message
    const errorElement = document.querySelector("[data-newsletter-error]");
    if (errorElement) {
      errorElement.remove();
    }

    // Remove error styling from email input
    this.emailTarget.classList.remove(
      "border-red-400",
      "focus-visible:ring-red-400",
    );
  }

  // Handle form submission completion (called by Turbo)
  "turbo:submit-end"(event) {
    this.hideLoading();

    // If there was an error in form submission, we'll get redirected back
    // The flash message will handle showing the error
  }
}
